import {useState, useEffect} from 'react';
import {Button, Card, Table} from 'antd';
import {getCart, clearCartForUser} from "../../api/Api";
import {Link} from "react-router";
import {fixedToDisplayUnit} from "../../util/unitutils";
import {CategoryType, UnitType} from "../../api/Constants";
import {BookStatusTag} from "../inventory/BookStatusTag";

export const CartView = ({session, onApiFail,  props}) => {
    const [inventory, setInventory] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const onRefresh = () => {
        setRefresh(refresh+1);
    }

    useEffect(() => {
        getCart().then(r => {
            setInventory(r.map(row => {
                return {
                    ...row,
                    key: row.inventoryId
                }
            }).filter(row => {
                return row.quantity > 0
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refresh, onApiFail]);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                return <Link to={`/inventory/${record.id}`}>{val}</Link>
            },
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.category === CategoryType.Wholesale) {
                    return `${displayQuantity} ${UnitType.Label[record.unit]}`
                }
                return displayQuantity;
            },
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (val, record, index) => {
                return CategoryType.Label[val]
            },
        },
        {
            title: 'Book',
            dataIndex: 'book',
            key: 'book',
            render: (val, record, index) => {
                return <BookStatusTag book={val} />
            },
        }
    ];

    const onClear = () => {
        clearCartForUser().then(r => {
            onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const cardStyle = {
        textAlign: 'left'
    }

    return <Card style={cardStyle} title={<b>Reserved Inventory</b>}>
        <div style={{color: 'red', marginTop: '5px', marginBottom: '5px'}}>
            Inventory that has been temporarily reserved by you.
        </div>
        <div style={{marginTop: '5px', marginBottom: '5px'}}>
            <Table dataSource={inventory} columns={columns} pagination={false}/>
        </div>
        <div style={{marginTop: '5px', marginBottom: '5px'}}>
            <Button onClick={onClear}>
                Clear Reserve
            </Button>
        </div>
    </Card>
}